import React, { useCallback, useEffect, useRef, useState } from 'react';
import { TableInput } from '../../../../components/common';
import { Table } from '../../../../components/ui/renderTable/styled';
import axios from 'axios';
import AutocompleteMuiCustom from '../../../../components/common/AutocompleteMuiCustom';
import {
  AddButton,
  SaveButton,
} from '../../../../components/common/button/CustomButtons';
import { getBgColorOfRemainingQty } from '../helpers/remainingQtyColor';
import { DeleteIconButton } from '../../../../components/common/button/CustomIconButton';

const LocationTableModal = (props: any) => {
  const { setIsLocationOpenPopup, handleSaveTableData, initialData, okQty } =
    props;
  const [compartments, setCompartment] = useState([]);
  const remainingQty = useRef(okQty);
  const [rack, setRack] = useState([]);
  const [rackId, setRackId] = useState<any>({});
  const [tableData, setTableData] = useState<any>([
    {
      compartment_id: null,
      qty: null,
      _tempId: `temp-id-${new Date().getTime()}`,
    },
  ]);

  const calculateRemainingQty = (arr: any, okQty: any) => {
    const accumulatedQty = arr.reduce((accumulator: any, currentItem: any) => {
      return accumulator + (+currentItem.qty || 0);
    }, 0);

    return (okQty || 0) - (+accumulatedQty || 0);
  };
  useEffect(() => {
    if (initialData) {
      remainingQty.current = calculateRemainingQty(initialData, okQty);
      setTableData(initialData);
    }
    axios
      .get(`/api/storeSetupRoutes`)
      .then((res) => {
        if (res?.data) {
          setRack(res?.data);
        }
      })
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    axios
      .get(
        `/api/storeCompartmentRoutes/autocompleteByRack?rackId=${rackId?._id}`
      )
      .then((res) => {
        if (res?.data) {
          setCompartment(res?.data);
        }
      })
      .catch((err) => console.log(err));
  }, [rackId?._id]);

  const addRows = useCallback(() => {
    setTableData((prev: any) => {
      return [
        ...prev,
        {
          compartment_id: null,
          qty: null,
          _tempId: `temp-id-${new Date().getTime()}`,
        },
      ];
    });
  }, []);

  const handelDeleteRows = async (rowIdx: number) => {
    // const ans = await confirmDeleteRow();
    // if (!ans) return;

    setTableData((prev: any) => {
      const filteredData = prev.filter((_: any, i: number) => i !== rowIdx);
      remainingQty.current = calculateRemainingQty(filteredData, okQty);
      return filteredData;
    });
  };

  const handleData = useCallback(
    (rowIndex: number | null, key: string, newValues: any) => {
      setTableData((prev: any) => {
        const upadateCompartment: any = [...prev];
        if (rowIndex === null) return;
        const updatedRow = upadateCompartment?.[rowIndex];
        updatedRow[key] = newValues;
        upadateCompartment[rowIndex] = updatedRow;
        if (key === 'qty' && okQty > 0) {
          remainingQty.current = calculateRemainingQty(
            upadateCompartment,
            okQty
          );
        }
        return upadateCompartment;
      });
    },
    []
  );

  const handleInputChange = (
    fieldName: string,
    value: string | number | null,
    index: number
  ) => {
    handleData(index, fieldName, value);
  };

  const handleSave = () => {
    if (remainingQty.current !== 0) {
      alert(
        '🚫 Remaining Qty must be 0. Please provide the necessary quantities.'
      );
      return;
    }
    const allRowsFilled = tableData.every(
      (row: any) => row.compartment_id !== null
    );
    const allQuantityFilled = tableData.every((row: any) => row.qty !== null);
    if (!allRowsFilled) {
      alert(
        '🚫 All RI PARTS must be completed. Please fill in all the required fields.'
      );
      return;
    }
    if (!allQuantityFilled) {
      alert(
        '🚫 All Quantity fields must be completed. Please provide the necessary quantities.'
      );
      return;
    }
    handleSaveTableData(tableData);
    setIsLocationOpenPopup(false);
  };

  return (
    <>
      <div
        style={{
          position: 'absolute',
          right: '135px',
          top: '0px',
        }}
      >
        <SaveButton
          label="Save"
          onClick={() => {
            handleSave();
          }}
          sx={{ background: '#1864ab' }}
        />
      </div>
      <div
        style={{
          position: 'absolute',
          right: '250px',
          top: '0px',
        }}
      >
        <AddButton
          onClick={() => {
            addRows();
          }}
          label="Add Part"
          sx={{ background: '#1864ab' }}
        />
      </div>
      <div>
        <AutocompleteMuiCustom
          id="name"
          label=""
          option_name="name"
          arrayofObj={rack}
          value={rackId || ''}
          onChange={(e, value) => {
            setRackId(value);
          }}
        />
      </div>
      <Table style={{ width: '80vh' }}>
        <thead>
          <tr>
            <th colSpan={2}>OK Qty : {okQty || null} </th>
            <th
              colSpan={2}
              style={{
                background: getBgColorOfRemainingQty(remainingQty.current),
              }}
            >
              Remaining : {remainingQty.current}
            </th>
          </tr>
          <tr>
            <th>S.No.</th>
            <th>Rack Location</th>
            <th>Qty</th>
            <th>Delete</th>
          </tr>
        </thead>
        <tbody>
          {tableData?.map((part: any, index: number) => (
            <tr key={part?._id || part?._tempId}>
              <th>{index + 1}</th>
              <td style={{ minWidth: '150px', textAlign: 'center' }}>
                <AutocompleteMuiCustom
                  id="name"
                  label=""
                  option_name="name"
                  arrayofObj={compartments}
                  value={part?.compartment_id || ''}
                  onChange={(e, value) => {
                    handleInputChange('compartment_id', value, index);
                  }}
                />
              </td>
              <td style={{ minWidth: '100px', textAlign: 'center' }}>
                <TableInput
                  name="qty"
                  key="qty"
                  type="number"
                  isView={false}
                  value={part?.qty}
                  onChange={(e) => {
                    handleInputChange('qty', e.target.value, index);
                  }}
                />
              </td>
              <td>
                <DeleteIconButton
                  tooltipTitle={'delete Row'}
                  onClick={() => handelDeleteRows(index)}
                />
              </td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          {/* <tr>
          <th colSpan={2}>Total QUANTITY</th>
          <th>{}</th>
        </tr> */}
        </tfoot>
      </Table>
    </>
  );
};

export default LocationTableModal;
